import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import {
  ActivateSubscriptionRequest,
  CancelSubscriptionRequest,
  ChangeSubscriptionRequest,
  PauseSubscriptionRequest,
  ReactivateSubscriptionRequest,
  SubscribeRequest,
} from '@shared/restaurant/models';
import { ApiClientService } from '@tablesready/api-client';
import { PricePlan } from '@shared/price-plan/models';

@Injectable({providedIn: 'root'})
export class SubscriptionService {
  private readonly basePath = '/v.1/subscription';

  constructor(private readonly http: ApiClientService) {
  }

  cancel(options: CancelSubscriptionRequest) {
    return this.http.post<any>(`${this.basePath}/cancel`, options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  change(options: ChangeSubscriptionRequest): Observable<any> {
    return this.http.put<any>(`${this.basePath}/change`, options);
  }

  activate(options: ActivateSubscriptionRequest) {
    return this.http.post<any>(`${this.basePath}/activate`, options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  pause(options: PauseSubscriptionRequest) {
    return this.http.post<any>(`${this.basePath}/pause`, options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  reactivate(options: ReactivateSubscriptionRequest) {
    return this.http.post<any>(`${this.basePath}/reactivate`, options)
      .pipe(map(({ success, error, data }) => this.responseHandler(success, error, data)));
  }

  checkSubscription(subscriptionUuid: string): Observable<PricePlan> {
    return this.http.get<PricePlan>(`${this.basePath}/check/${subscriptionUuid}`);
  }

  private responseHandler<T>(success, error, data: T): T {
    if (success) {
      return data;
    }

    throw Error(String(error));
  }
}
